export var MuiPaper = {
    styleOverrides: {
        root: function () { return ({
            borderRadius: 0,
        }); },
    },
};
